import {filterTypes as filterTypes} from "@/enums/filterTypes";

export const slugify = (input, separator = '-') => {
  return (input || '')
    .toString()
    .normalize('NFD') // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036F]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, separator)
}


export const mapFilters = (filters, pageNo, pageSize, sortBy, sortAsc) => {
  let filter = {}
  filters.map((f) => {
    if (f.value) {
      if(Array.isArray(f.value)){
        if(f.type !==  filterTypes.RANGE) {
          Object.assign(filter, {[f.property]: f.value.toString()})
        }
        else {
          Object.assign(filter, {[f.property]: f.value[0]})
          Object.assign(filter, {[f.property2]: f.value[1]})

        }

      }
      else{
        Object.assign(filter, {[f.property]: f.value})
      }
    }
  })
  Object.assign(filter, {pageNo: pageNo})
  Object.assign(filter, {pageSize: pageSize})
  Object.assign(filter, {sortBy: sortBy || ''})
  Object.assign(filter, {sortAsc: sortAsc})

  return filter
}
